import { GetCampaignRes } from "../api";
import {
  afd_profile_image_anniversary,
  afd_profile_image_birthday,
  afd_profile_image_christmas,
  afd_profile_image_other,
  afd_profile_image_wedding,
  afd_theme_bg_anniversary,
  afd_theme_bg_birthday,
  afd_theme_bg_christmas,
  afd_theme_bg_other,
  afd_theme_bg_wedding,
} from "../imgs";

export type ThemeVisualKey = "other" | "birthday" | "wedding" | "anniversary" | "christmas";

const THEME_VISUALS: Record<ThemeVisualKey, { cover: string; profile: string }> = {
  other: {
    cover: afd_theme_bg_other,
    profile: afd_profile_image_other,
  },
  birthday: {
    cover: afd_theme_bg_birthday,
    profile: afd_profile_image_birthday,
  },
  wedding: {
    cover: afd_theme_bg_wedding,
    profile: afd_profile_image_wedding,
  },
  anniversary: {
    cover: afd_theme_bg_anniversary,
    profile: afd_profile_image_anniversary,
  },
  christmas: {
    cover: afd_theme_bg_christmas,
    profile: afd_profile_image_christmas,
  },
};

const getThemeVisualKey = (themeName?: string): ThemeVisualKey => {
  const normalized = `${themeName ?? ""}`.trim().toLowerCase();

  if (normalized.includes("birth") || normalized.includes("生日")) return "birthday";
  if (normalized.includes("wed") || normalized.includes("marriage") || normalized.includes("婚")) return "wedding";
  if (normalized.includes("anniversary") || normalized.includes("週年") || normalized.includes("周年")) return "anniversary";
  if (normalized.includes("christmas") || normalized.includes("xmas") || normalized.includes("聖誕")) return "christmas";
  return "other";
};

export const getCampaignThemeFallback = (themeName?: string) => {
  return THEME_VISUALS[getThemeVisualKey(themeName)];
};

export const getCampaignThemeImages = (campaign?: GetCampaignRes, themeName?: string) => {
  const fallback = getCampaignThemeFallback(themeName);
  const cover = campaign?.campaignAssets?.find(item => item.position === "cover")?.url || fallback.cover;
  const profile = campaign?.campaignAssets?.find(item => item.position === "profile")?.url || fallback.profile;

  return {
    cover,
    profile,
  };
};
